module.exports = __webpack_public_path__ + "assets/img/teacher (24).a597bb78.png";